
// Utilities
import { mapMutations, mapState } from 'vuex';

export default {
  data: () => ({
    colors: ['primary', 'info', 'success', 'warning', 'danger'],
    images: [
      'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
      'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-3.3a54f533.jpg',
      'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-4.3b7e38ed.jpg',
    ],
  }),

  computed: {
    ...mapState('app', ['image', 'color']),
    color(): any {
      return (this as any).$store.state.app.color;
    },
  },

  methods: {
    ...mapMutations('app', ['setImage']),
    setColor(color: any) {
      (this as any).$store.state.app.color = color;
    },
  },
};
